fourToldApp.controller("termsCntrl", function($scope, esb, services, $window, $routeParams, $location, $mdToast, $mdDialog, theme, $q) {
    $scope.aditional = new Object();
    $scope.theme = theme.getTheme();
    let src = null;
    if($location.search().land === 'reg'){
      $window.sessionStorage.setItem("redirectTerms", "data");
      let lang = $location.search().lang;
      let tag = $location.search().tag;

      $window.sessionStorage.setItem("lang", lang);
      let params = {};
      if (tag)
          params.code = tag;
      if (lang)
          params.lang = lang;
          src = services.language.setLanguage(params, {}, function(response) {
          $scope.urlTerms = {
              src: esb + "/security" + response.data.url,
              title: "Egghead.io AngularJS Binding"
          };
      }, function err() {
          console.log("error cargando la data");
      });
    } else {
      $scope.urlTerms = {
          src: esb + "/security" + $window.sessionStorage.getItem("urlTerms"),
          title: "Egghead.io AngularJS Binding"
      };
      src = $scope.urlTerms.src;
    }

    $q.all([
        src.$promise
    ]).then(function(){
        fetch($scope.urlTerms.src/*, options */)
            .then((response) => response.text())
            .then((html) => {
                document.getElementById("add_to_me").innerHTML = html;
                document.getElementById('terms_checkbox').style.visibility = "visible";
            })
            .catch((error) => {
                console.warn(error);
            });
    });
    $scope.TCAccepted = function(data) {
        $scope.success = true;
        if(data === true){
            $routeParams.register = true;
            $location.path("/register");
        }else {
            $scope.success = false;
            $mdDialog.show({
                locals:{theme: theme.getTheme()},
                controller: DialogController,
                template: '<md-dialog aria-label="internet" id="offline">' +
                            '<md-dialog-content style="max-width:600px;max-height:810px; padding: 3%; padding-bottom:0;">'+
                                '<h3>Atención</h3>'+
                                '<h4 for="">{{message}}</h4>'+
                            '</md-dialog-content>'+
                            '<md-dialog-actions layout="row">'+
                            '    <md-button ng-click="answer()">'+
                            '        Ok'+
                            '    </md-button>'+
                            '</md-dialog-actions>'+
                        '</md-dialog>',
                parent: angular.element(document.body),
                clickOutsideToClose:true
            }).then(function (answer) {});
        }
    };
    function DialogController($scope, $mdDialog, theme) {
        $scope.message = "Debes aceptar los términos y condiciones para poder continuar el proceso."
        if(theme.terms_and_conditions)
            $scope.message = theme.terms_and_conditions.checkLabel;
        $scope.answer = function () {
          $mdDialog.hide();
        };
    };
    $scope.cancel = function() {
        if($location.search().land)
          window.history.back();
        else $location.path('/');
    };
    function dialog(message, type){
        $mdToast.show(
            $mdToast.simple()
            .textContent(message)
            .position('top')
            .action('Ok')
            .theme(type)
            .hideDelay(0)
        );
    };
    $scope.validateChecks = function(value, name) {
        var t = theme.getTheme();
        if (t.terms_and_conditions && t.terms_and_conditions.options){
            $scope.markedOptions = $scope.markedOptions || {};
            $scope.markedOptions[name] = value;
        }
        var allChecked = true;
        t.terms_and_conditions.options.forEach(item => {
            if (!$scope.markedOptions[item.name]){
                allChecked = false;
            }
        });
        $scope.accepted = allChecked;
    };
});
